import { Table } from "react-bootstrap";
import { ChangeWasteState } from "useCases/wastes/ChangeWasteState";
import { UpdateWaste } from "useCases/wastes/UpdateWaste";
import { SortedTh } from "../Abstractions/SortedTh";
import { StatusBadge } from "../Abstractions/StatusBadge";

export function WastesTable({ wastes, sorting, itemActions }) {
  const columnsNames = {
    "internalName": "Nazwa wewnętrzna",
    "wasteCode": "Kod odpadu",
    "externalName": "Nazwa formalna",
    "kinds": "Gatunki",
    "wasteCodeBdoId": "Ref. BDO",
    "isDeleted": "Status",
    "actions": "Akcje"
  }

  const table = (
    <>
      <Table hover>
        <thead>
          <tr>
            {Object.entries(columnsNames).map(([value, name]) =>
              <SortedTh key={value} sorting={sorting} itemActions={itemActions} sortingValue={value}>{name}</SortedTh>)}
          </tr>
        </thead>
        <tbody>
          {wastes.loading && (
            <>
              <tr className="spinner-border"></tr>
            </>
          )}
          {wastes.length > 0 &&
            wastes.map((item, index) => (
              <tr key={index}>
                <td style={{ width: "15%" }}>{item.internalName}</td>
                <td style={{ width: "10%" }}>{item.wasteCode}</td>
                <td style={{ width: "25%" }}>{item.externalName}</td>
                <td style={{ width: "25%" }}>{item.kinds.map(x => x.name).join(", ")}</td>
                <td>{item.wasteCodeBdoId}</td>
                <td><StatusBadge isActive={!item.isDeleted}/></td>
                <td>
                  <UpdateWaste waste={item} />
                  <ChangeWasteState waste={item} />
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    </>
  );

  return <>{table}</>;
}